import { useState } from 'react'

import { DateTimeProvider } from '../../DateTime'
import { ComponentProps } from '../Component'
import { controls, language, timeZone } from '../Controls'

export function DateTimeProviderProps({ children }) {
  const [props, setProps] = useState(() =>
    controls() //
      .add(language('language'))
      .add(timeZone('timeZone'))
  )

  return (
    <DateTimeProvider {...props.getValues()}>
      {children}
      <ComponentProps
        name='DateTimeProvider'
        value={props}
        onChange={setProps}
      />
    </DateTimeProvider>
  )
}
